module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/8-1256978bd0e1e4f3244f9b9ea8622e5d.svg";